import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { Mail, ShoppingBag, MessagesSquare } from "lucide-react";
import { useT } from "@/context/LangContext";
import MyShipments from "@/components/MyShipments";
import MyDeposits from "@/components/MyDeposits";

export default function Dashboard() {
  const t = useT();
  const { user } = useAuth();
  if (!user || user === false) return null;

  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16" data-testid="dashboard-page">
      <p className="kicker">{t("dash.kicker")}</p>
      <h1 className="font-display text-4xl lg:text-5xl font-black mt-3">{t("dash.welcome")}, {user.name}.</h1>
      <p className="text-[var(--ink-soft)] mt-4 max-w-xl">{t("dash.desc")}</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
        <Link to="/contact" className="card-flat p-8" data-testid="dash-card-quote">
          <Mail className="text-[var(--accent)]" />
          <h3 className="font-display text-xl font-bold mt-5">{t("dash.card1.t")}</h3>
          <p className="text-[var(--ink-soft)] text-sm mt-2">{t("dash.card1.d")}</p>
        </Link>
        <Link to="/produits" className="card-flat p-8" data-testid="dash-card-shop">
          <ShoppingBag className="text-[var(--accent)]" />
          <h3 className="font-display text-xl font-bold mt-5">{t("dash.card2.t")}</h3>
          <p className="text-[var(--ink-soft)] text-sm mt-2">{t("dash.card2.d")}</p>
        </Link>
        <div className="card-flat p-8" data-testid="dash-card-chat">
          <MessagesSquare className="text-[var(--accent)]" />
          <h3 className="font-display text-xl font-bold mt-5">{t("dash.card3.t")}</h3>
          <p className="text-[var(--ink-soft)] text-sm mt-2">{t("dash.card3.d")}</p>
        </div>
      </div>

      <div className="mt-12 card-flat p-8">
        <p className="kicker">{t("dash.account")}</p>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-4">
          <div><p className="text-xs uppercase tracking-widest text-[var(--ink-soft)]">{t("auth.email")}</p><p className="font-bold mt-1">{user.email}</p></div>
          <div><p className="text-xs uppercase tracking-widest text-[var(--ink-soft)]">{t("dash.role")}</p><p className="font-bold mt-1 capitalize">{user.role}</p></div>
        </div>
      </div>

      <MyShipments />
      <MyDeposits />
    </div>
  );
}
